import React from "react";
import { LandingPublicHotelBookingMock } from "./LandingPublicHotelBookingMock";

/** דמו ויזואלי מופשט — לא מציג צילום מסך; מדמה את שפת הממשק (כחול / כתום / לבן). */

function MockChrome({ children }) {
  return (
    <div className="hr-landing-mock">
      <div className="hr-landing-mock__toolbar" aria-hidden>
        <span className="hr-landing-mock__dot" />
        <span className="hr-landing-mock__dot hr-landing-mock__dot--amber" />
        <span className="hr-landing-mock__dot hr-landing-mock__dot--green" />
        <div className="hr-landing-mock__url" />
      </div>
      <div className="hr-landing-mock__body">{children}</div>
    </div>
  );
}

function HotelSearchMock() {
  return (
    <MockChrome>
      <div className="hr-landing-mock__row hr-landing-mock__row--tabs">
        <span className="hr-landing-mock__pill hr-landing-mock__pill--active">מלונות</span>
        <span className="hr-landing-mock__pill">חבילות</span>
        <span className="hr-landing-mock__pill">טיסות</span>
      </div>
      <div className="hr-landing-mock__searchRow">
        <div className="hr-landing-mock__field hr-landing-mock__field--wide" />
        <div className="hr-landing-mock__field" />
        <div className="hr-landing-mock__field" />
        <div className="hr-landing-mock__cta" />
      </div>
      <div className="hr-landing-mock__grid2">
        <div className="hr-landing-mock__card">
          <div className="hr-landing-mock__cardImg" />
          <div className="hr-landing-mock__cardLine" />
          <div className="hr-landing-mock__cardLine hr-landing-mock__cardLine--short" />
        </div>
        <div className="hr-landing-mock__card">
          <div className="hr-landing-mock__cardImg" />
          <div className="hr-landing-mock__cardLine" />
          <div className="hr-landing-mock__cardLine hr-landing-mock__cardLine--short" />
        </div>
      </div>
    </MockChrome>
  );
}

function VacationMock() {
  return (
    <MockChrome>
      <div className="hr-landing-mock__heroStrip" />
      <div className="hr-landing-mock__grid3">
        {[1, 2, 3].map((k) => (
          <div key={k} className="hr-landing-mock__vacCard">
            <div className="hr-landing-mock__vacImg" />
            <div className="hr-landing-mock__cardLine" />
            <div className="hr-landing-mock__price" />
          </div>
        ))}
      </div>
    </MockChrome>
  );
}

function DashboardMock() {
  return (
    <MockChrome>
      <div className="hr-landing-mock__dash">
        <div className="hr-landing-mock__sidebar" />
        <div className="hr-landing-mock__main">
          <div className="hr-landing-mock__kpis">
            {[1, 2, 3].map((k) => (
              <div key={k} className="hr-landing-mock__kpi">
                <div className="hr-landing-mock__kpiLabel" />
                <div className="hr-landing-mock__kpiVal" />
              </div>
            ))}
          </div>
          <div className="hr-landing-mock__panel" />
        </div>
      </div>
    </MockChrome>
  );
}

function OrdersMock() {
  return (
    <MockChrome>
      <div className="hr-landing-mock__tableHead">
        <span />
        <span />
        <span />
        <span />
      </div>
      {[1, 2, 3, 4].map((k) => (
        <div key={k} className="hr-landing-mock__tableRow">
          <div className="hr-landing-mock__cell hr-landing-mock__cell--strong" />
          <div className="hr-landing-mock__cell" />
          <div className="hr-landing-mock__badge" />
          <div className="hr-landing-mock__cell hr-landing-mock__cell--link" />
        </div>
      ))}
    </MockChrome>
  );
}

function ProposalMock() {
  return (
    <MockChrome>
      <div className="hr-landing-mock__proposal">
        <div className="hr-landing-mock__proposalHead" />
        <div className="hr-landing-mock__proposalBlock" />
        <div className="hr-landing-mock__proposalPrice" />
        <div className="hr-landing-mock__proposalActions">
          <div className="hr-landing-mock__proposalBtn hr-landing-mock__proposalBtn--primary" />
          <div className="hr-landing-mock__proposalBtn" />
        </div>
      </div>
    </MockChrome>
  );
}

function FinanceMock() {
  return (
    <MockChrome>
      <div className="hr-landing-mock__financeRow">
        <div className="hr-landing-mock__stat" />
        <div className="hr-landing-mock__stat" />
        <div className="hr-landing-mock__stat hr-landing-mock__stat--accent" />
      </div>
      <div className="hr-landing-mock__chart">
        <div className="hr-landing-mock__bar" style={{ height: "40%" }} />
        <div className="hr-landing-mock__bar" style={{ height: "65%" }} />
        <div className="hr-landing-mock__bar" style={{ height: "50%" }} />
        <div className="hr-landing-mock__bar" style={{ height: "80%" }} />
        <div className="hr-landing-mock__bar" style={{ height: "55%" }} />
      </div>
    </MockChrome>
  );
}

const MAP = {
  hotelSearch: HotelSearchMock,
  hotelSearchPublicSite: LandingPublicHotelBookingMock,
  vacation: VacationMock,
  dashboard: DashboardMock,
  orders: OrdersMock,
  proposal: ProposalMock,
  finance: FinanceMock,
};

export function LandingAbstractMockup({ variant }) {
  const Cmp = MAP[variant] || HotelSearchMock;
  return <Cmp />;
}

/** קולאז' ל־Hero — שני חלונות בזווית */
export function LandingHeroMockupCollage() {
  return (
    <div className="hr-landing-hero-collage" aria-hidden>
      <div className="hr-landing-hero-collage__back">
        <LandingAbstractMockup variant="dashboard" />
      </div>
      <div className="hr-landing-hero-collage__front">
        <LandingAbstractMockup variant="hotelSearch" />
      </div>
    </div>
  );
}
